import { BRAND } from "@/brand";
import { Link } from "wouter";
import { Mail, Phone, Instagram, Linkedin, Facebook } from "lucide-react";
import { useLang } from "@/contexts/LanguageContext";
import { getDict } from "@/lib/i18n";

export default function PublicFooter() {
  const { lang } = useLang();
  const t = getDict(lang);

  return (
    <footer className="bg-[var(--forest)] text-[var(--cream)] mt-24">
      <div className="container py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-4">
            <img
              src={BRAND.logoStackedCreamTransparent}
              alt="Golf Motion Lab"
              className="h-28 w-auto object-contain"
            />
            <p className="mt-6 text-sm leading-relaxed text-[var(--cream)]/75 max-w-sm">
              {t.footer.brandText}
            </p>

            <div className="mt-6 flex items-center gap-3">
              <a
                href={BRAND.instagram}
                target="_blank"
                rel="noreferrer"
                aria-label="Instagram"
                className="h-10 w-10 rounded-full border border-[var(--cream)]/20 flex items-center justify-center text-[var(--cream)]/80 hover:bg-[var(--cream)] hover:text-[var(--forest)] transition-colors"
              >
                <Instagram size={18} />
              </a>
              <a
                href={BRAND.linkedin}
                target="_blank"
                rel="noreferrer"
                aria-label="LinkedIn"
                className="h-10 w-10 rounded-full border border-[var(--cream)]/20 flex items-center justify-center text-[var(--cream)]/80 hover:bg-[var(--cream)] hover:text-[var(--forest)] transition-colors"
              >
                <Linkedin size={18} />
              </a>
              <a
                href={BRAND.facebook}
                target="_blank"
                rel="noreferrer"
                aria-label="Facebook"
                className="h-10 w-10 rounded-full border border-[var(--cream)]/20 flex items-center justify-center text-[var(--cream)]/80 hover:bg-[var(--cream)] hover:text-[var(--forest)] transition-colors"
              >
                <Facebook size={18} />
              </a>
            </div>
          </div>

          <div className="md:col-span-3">
            <h4 className="font-display text-base font-medium mb-4 text-[var(--cream)]">
              {t.footer.navTitle}
            </h4>
            <ul className="space-y-2.5 text-sm text-[var(--cream)]/75">
              <li><a href="/#metodologia" className="hover:text-[var(--cream)] transition-colors">{t.footer.nav.metodologia}</a></li>
              <li><a href="/#tecnologia" className="hover:text-[var(--cream)] transition-colors">{t.footer.nav.tecnologia}</a></li>
              <li><a href="/equipo" className="hover:text-[var(--cream)] transition-colors">{t.footer.nav.equipo}</a></li>
              <li><a href="/#contacto" className="hover:text-[var(--cream)] transition-colors">{t.footer.nav.contacto}</a></li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <h4 className="font-display text-base font-medium mb-4 text-[var(--cream)]">
              {t.footer.contactTitle}
            </h4>
            <ul className="space-y-3 text-sm text-[var(--cream)]/75">
              <li className="flex items-start gap-2.5">
                <Mail size={16} className="mt-0.5 shrink-0" />
                <a href={`mailto:${BRAND.email}`} className="hover:text-[var(--cream)]">{BRAND.email}</a>
              </li>
              <li className="flex items-start gap-2.5">
                <Phone size={16} className="mt-0.5 shrink-0" />
                <a href={BRAND.whatsappLink} target="_blank" rel="noreferrer" className="hover:text-[var(--cream)]">{BRAND.whatsappDisplay}</a>
              </li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <h4 className="font-display text-base font-medium mb-4 text-[var(--cream)]">
              {t.footer.legalTitle}
            </h4>
            <ul className="space-y-2.5 text-sm text-[var(--cream)]/75">
              <li><Link href="/privacidad" className="hover:text-[var(--cream)]">{t.footer.legal.privacidad}</Link></li>
              <li><Link href="/aviso-legal" className="hover:text-[var(--cream)]">{t.footer.legal.aviso}</Link></li>
              <li><Link href="/cookies" className="hover:text-[var(--cream)]">{t.footer.legal.cookies}</Link></li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-[var(--cream)]/15 flex flex-col md:flex-row justify-between gap-3 text-xs text-[var(--cream)]/55">
          <span>© {new Date().getFullYear()} {BRAND.name}. {t.footer.rights}</span>
          <span>{BRAND.domain}</span>
        </div>
      </div>
    </footer>
  );
}
